import { render } from "./paymentSuccess.vue?vue&type=template&id=3e848c42"
import script from "./paymentSuccess.vue?vue&type=script&lang=js"
export * from "./paymentSuccess.vue?vue&type=script&lang=js"

import "./paymentSuccess.vue?vue&type=style&index=0&id=3e848c42&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__